import React, { useEffect, useState } from "react";
import { Table, Tag, Button,Upload, message, Modal  } from "antd";
import { DownloadOutlined,UploadOutlined  } from "@ant-design/icons";
import courseService from "../../services/course.service";
import UploadResponse from "./UploadResponse";



const TrainingViewer = ({ courseId,trainingId }) => {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        setLoading(true);
          // Récupération de l'utilisateur depuis localStorage
      const userData = JSON.parse(localStorage.getItem("user"));
      const userId = userData?.id;

      if (!userId) {
        console.warn("Aucun utilisateur trouvé dans le localStorage");
        return;
      }
        const data = await courseService.getTrainingExercisesByCourseByTriningIdAndUserId(trainingId,userId);
                // const data = await courseService.getTrainingExercisesByCourseByTriningId(trainingId);

        // alert(" my data of user is : " + JSON.stringify(data))
        setTrainings(data);
      } catch (error) {
        console.error("Erreur lors du chargement des exercices :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainings();
  }, [courseId,trainingId]);

  const handleUpload = async (exerciseId, file) => {
    try {
      await courseService.uploadStudentTrainingResponse(exerciseId, file);
      message.success("Fichier soumis avec succès !");
      // 🔁 Recharger les données pour voir le lien mis à jour
      const data = await courseService.getTrainingExercisesByCourse(courseId);
      setTrainings(data);
    } catch (err) {
      message.error("Erreur lors de la soumission du fichier.");
    }
  };
  


//   const columns = [
//     {
//       title: "Titre",
//       dataIndex: "title",
//       key: "title",
//       render: text => <strong>{text}</strong>,
//     },
//     {
//       title: "Note",
//       dataIndex: "grade",
//       key: "grade",
//       render: grade => <Tag color="blue">{grade ?? 0}</Tag>,
//     },
//     {
//       title: "Fichier modèle",
//       dataIndex: "templateFileUrl",
//       key: "templateFileUrl",
//       render: url =>
//         url ? (
//           <a href={url} target="_blank" rel="noopener noreferrer">
//             <DownloadOutlined /> Télécharger
//           </a>
//         ) : (
//           <Tag color="red">Aucun</Tag>
//         ),
//     },
//     // {
//     //   title: "Fichier étudiant",
//     //   dataIndex: "studentFileUrl",
//     //   key: "studentFileUrl",
//     //   render: url =>
//     //     url ? (
//     //       <a href={url} target="_blank" rel="noopener noreferrer">
//     //         <DownloadOutlined /> Voir
//     //       </a>
//     //     ) : (
//     //       <Tag color="gray">Non soumis</Tag>
//     //     ),
//     // },
//     {
//       title: "Fichier étudiant",
//       dataIndex: "studentFileUrl",
//       key: "studentFileUrl",
//       render: (url, record) => (
//         <>
//           {url ? (
//             <a href={url} target="_blank" rel="noopener noreferrer">
//               <DownloadOutlined /> Voir
//             </a>
//           ) : (
//             <Tag color="gray">Non soumis</Tag>
//           )}
//           {/* <Upload
//             showUploadList={false}
//             beforeUpload={(file) => {
//               handleUpload(record.id, file); // Envoie l'ID de l'exercice et le fichier
//               return false; // Empêche le comportement par défaut d'upload automatique
//             }}
//           >
//             <Button icon={<UploadOutlined />} size="small" type="link">
//               Soumettre réponse
//             </Button>
//           </Upload> */}
//           <UploadResponse
//   exerciseId={record.trainingExerciseId}
//   onUploadSuccess={async () => {
//     const data = await courseService.getTrainingExercisesByCourse(courseId);
//     setTrainings(data);
//   }}
// />

//         </>
//       ),
//     },
    
//   ];


// const columns = [
//   {
//     title: "Titre",
//     dataIndex: "title",
//     key: "title",
//     render: (text) => <strong>{text}</strong>,
//   },
//   // {
//   //   title: "Note",
//   //   key: "grade",
//   //   render: (_, record) => {
//   //     const grade = record.responses?.[0]?.grade ?? 0; 
//   //     return <Tag color="blue">{grade}</Tag>;
//   //   },
//   // },
//     {
//     title: "Note obtenue en (%)",
//     key: "grade",
//     render: (_, record) => {
//       const grade = record.responses?.[0]?.grade ?? 0; 
//       return <Tag color="blue">{grade}</Tag>;
//     },
//   },
//   {
//     title: "Fichier modèle",
//     dataIndex: "templateFileUrl",
//     key: "templateFileUrl",
//     render: (url) =>
//       url ? (
//         <a href={url} target="_blank" rel="noopener noreferrer">
//           <DownloadOutlined /> Télécharger
//         </a>
//       ) : (
//         <Tag color="red">Aucun</Tag>
//       ),
//   },
//   {
//     title: "Fichier étudiant",
//     key: "studentFileUrl",
//     render: (_, record) => {
//       const url = record.responses?.[0]?.studentFileUrl;
//       return (
//         <>
//           {url ? (
//             <a href={url} target="_blank" rel="noopener noreferrer">
//               <DownloadOutlined /> Voir
//             </a>
//           ) : (
//             <Tag color="gray">Non soumis</Tag>
//           )}
//           <UploadResponse
//             exerciseId={record.trainingExerciseId}
//             onUploadSuccess={async () => {
//               const data = await courseService.getTrainingExercisesByCourse(courseId);
//               setTrainings(data);
//             }}
//           />
//         </>
//       );
//     },
//   },
// ];


const columns = [
  {
    title: "Titre",
    dataIndex: "title",
    key: "title",
    render: (text) => <strong>{text}</strong>,
  },
  {
    title: "Note obtenue en (%)",
    key: "grade",
    align: "center",
    render: (_, record) => {
      const grade = record.responses?.[0]?.grade ?? 0; 
      return <Tag color="blue">{`${grade}%`}</Tag>;
    },
  },
  {
    title: "Fichier modèle",
    dataIndex: "templateFileUrl",
    key: "templateFileUrl",
    align: "center",
    render: (url) =>
      url ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          <DownloadOutlined /> Télécharger
        </a>
      ) : (
        <Tag color="red">Aucun</Tag>
      ),
  },
  {
    title: "Fichier(s) étudiant(s)",
    key: "studentFileUrl",
    align: "center",
    render: (_, record) => {
      return (
        <>
          {record.responses && record.responses.length > 0 ? (
            record.responses.map((resp) => (
              <div key={resp.id} style={{ marginBottom: "5px" }}>
                <a href={resp.studentFileUrl} target="_blank" rel="noopener noreferrer">
                  <DownloadOutlined /> Voir
                </a>{" "}
                <Tag color="blue">{resp.grade ?? 0}%</Tag>
              </div>
            ))
          ) : (
            <Tag color="gray">Non soumis</Tag>
          )}
          <UploadResponse
            exerciseId={record.trainingExerciseId}
            onUploadSuccess={async () => {
              const data = await courseService.getTrainingExercisesByCourse(courseId);
              setTrainings(data);
            }}
          />
        </>
      );
    },
  },
];

  return (
    <>
      <h3>📘 Liste des exercices pour ce cours</h3>
      <Table
        dataSource={trainings}
        columns={columns}
        rowKey="id"
        loading={loading}
        bordered
        pagination={{ pageSize: 5 }}
      />
    </>
  );
};

export default TrainingViewer;
